<!-- =========================================================================================
    File Name: EmailView.vue
    Description: Email Application - Single Email View (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

  <template>
    <div>
      <vs-sidebar click-not-close parent="#email-app" :hidden-background="true" class="full-vs-sidebar email-view-sidebar items-no-padding" v-model="isSidebarActive" position-right>
        <div class="mail-sidebar-content px-0 sm:pb-6 h-full" v-if="currentOnlineTest">
          <div class="flex flex-wrap items-center email-header justify-between lg:w-full md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg">
            <div class="flex mb-4">
              <div class="flex items-center">
                <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="$emit('closeSidebar')" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
                <h4 v-if="currentOnlineTest.title">{{ currentOnlineTest.title }}</h4>
              </div>
            </div>
            <div class="ml-10 mb-4 mt-1">
              <div class="email__actions--single flex items-baseline">
                <div class="vx-row"  v-if="activeUserLevel == 2 && activeWorkspace.service == true">
                  <vs-button v-if="!onlineTestMember.length && currentOnlineTest.state_val == 5" svg-classes="h-6 w-6" style="margin-right:10px;" class="plus" color="primary" type="border" icon="icon-file-plus" icon-pack="feather" @click="onlineTestMemberItem()" >제출하기</vs-button>
                </div>
                <feather-icon icon="EditIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" v-if="activeUserLevel >= 3 && activeWorkspace.service == true" @click="editOnlineTest()"></feather-icon>
                <feather-icon icon="TrashIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" v-if="activeUserLevel >= 3 && activeWorkspace.service == true" @click="deleteOnlineTest()"></feather-icon>
                <feather-icon :icon="$vs.rtl ? 'ChevronsRightIcon' : 'ChevronsLeftIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('previousMail')" />
                <feather-icon :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('nextMail')" />
              </div>
            </div>
          </div>
          <component :is="scrollbarTag" class="scroll-area-mail-content md:px-8 md:pb-8 pt-4 px-6 pb-6" :settings="settings" :key="$vs.rtl">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vx-card v-bind:class="vxCardObject" style="margin-top:10px; margin-bottom:10px;">
                  <h4 v-if="currentOnlineTest.state_val != -99 && currentOnlineTest.state_val < 0" class="text-white">{{currentOnlineTest.state_val*-1}}시간 후 시작</h4>
                  <h4 v-if="currentOnlineTest.state_val == -99"  class="text-white">종료</h4>
                  <h4 v-if="currentOnlineTest.state_val == 0" class="text-white">시험중</h4>
                  <h4 v-if="currentOnlineTest.state_val > 0" class="text-white">D-{{currentOnlineTest.state_val}}</h4>

                </vx-card>
                <vx-card style="margin-top:10px; margin-bottom:10px;" v-if="currentOnlineTest.state_val == 0">
                  <div class="vx-row justify-between">
                  <h4 style="margin-left:20px;"> 남은 시간 </h4>
                  <div class="count-down">
                    <countdown :time="getCountdonwTime()" @end="handleCountdownEnd">
                      <template slot-scope="props">
                        <div class="single-counter">
                          <span class="timer">{{ props.hours }}</span>
                          <span>시</span>
                        </div>
                        <div class="single-counter">
                          <span class="timer">{{ props.minutes }}</span>
                          <span>분</span>
                        </div>
                        <div class="single-counter">
                          <span class="timer">{{ props.seconds }}</span>
                          <span>초</span>
                        </div>
                      </template>
                    </countdown>
                  </div>
                </div>
              </vx-card>
              </div>
            </div>
            <div v-if="isSidebarActive">
              <!-- LATEST MESSAGE -->
              <div class="vx-row">
                <div class="vx-col w-full">
                  <vx-card class="px-4">
                    <div class="vx-row">
                      <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
                        <div class="flex items-center">
                          <div class="flex flex-col">
                            <h5 class="mb-1">{{ currentOnlineTest.name }}</h5>
                          </div>
                        </div>
                        <div class="flex flex-col justify-end">
                          <span class="text-right">{{ currentOnlineTest.start_time | time }}</span>
                          <div class="flex justify-end mt-2">
                            <span class="text-right">{{ currentOnlineTest.start_time | date(true) }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="vx-row" v-if="currentOnlineTest.state_val == 0">
                      <div class="output ql-snow">
                        <div class="ql-editor" v-html="currentOnlineTest.detail"></div>
                      </div>
                    </div>
                    <div class="vx-row" v-if="currentOnlineTest.state_val != 0">
                      <div class="output ql-snow">
                        <h5> 시험 시간에만 내용을 확인 할수 있습니다.</h5>
                      </div>
                    </div>
                  </vx-card>
                </div>
              </div>
              <div class="vx-row" style="margin-top: 2.2rem">
                <div class="vx-col w-full"  v-for="(item, index) in onlineTestFileList" v-bind:key="index" style="margin-bottom:10px;">
                  <vx-card>
                    <div class="vx-row">
                      <div class="vx-col w-full flex justify-between">
                        <span class="text-lg">{{item}} </span>
                        <feather-icon v-if="activeUserLevel >= 2" svg-classes="h-6 w-6" class="cursor-pointer ml-4" icon="DownloadIcon" @click="fileDonwload(item)"></feather-icon>
                      </div>
                    </div>
                  </vx-card>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <vx-card class="px-4" style="margin-top:10px;">
                    <div id="data-list-list-view" class="data-list-container">
                      <vs-table ref="table"  pagination  :data="onlineTestMember">
                        <div slot="header" class="vx-row w-full text-center">
                          <h4 style="margin-top:5px;"> 제출 리스트 </h4>
                          <vx-tooltip text="전체 다운로드" position="top">
                            <vs-button v-if="activeUserLevel >= 3 && currentOnlineTest.state_val == -99" @click="downloadAllFile()" color="primary" icon="icon-download" icon-pack="feather" type="border" size="small" style="margin-left:10px; margin-bottom:10px; margin-top:2px;"/>
                          </vx-tooltip>
                        </div>
                        <template slot="thead">
                          <vs-th sort-key="name">이름</vs-th>
                          <vs-th sort-key="popularity">제출파일</vs-th>
                          <vs-th sort-key="category">제출일</vs-th>
                          <vs-th sort-key="category">성적</vs-th>
                          <vs-th></vs-th>
                        </template>
                        <template slot-scope="{data}">
                          <tbody>
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                              <vs-td>
                                <p class="product-name font-medium truncate">{{ tr.name }}</p>
                              </vs-td>
                              <vs-td>
                                <vx-tooltip :text="tr.file_name" position="top">
                                  <vs-button class="product-price" type="flat" style="width:200px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; display:inline-block; padding-left:12px; padding-right:12px;" @click="downloadFile(tr)">{{ tr.file_name }}</vs-button>
                                </vx-tooltip>
                              </vs-td>
                              <vs-td>
                                <div class="flex mt-2" style="width:100px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; display:inline-block">
                                  <p class="product-category">{{ tr.update_time | onlydate(true) }}</p> &nbsp;
                                  <div class="flex flex-row">
                                    <p class="text-right">{{ tr.update_time | time(true) }}</p>
                                  </div>
                                </div>
                              </vs-td>
                              <vs-td>
                                <p @click="score(tr)">{{tr.score}}</p>
                              </vs-td>
                              <vs-td class="whitespace-no-wrap">
                                <feather-icon v-if="activeUserLevel >= 3 && currentOnlineTest.state_val == -99 && activeWorkspace.service == true" icon="CheckIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="editScore(tr)"/>
                                <!-- TODO 추후 수정 필요.
                                <feather-icon v-if="activeUserLevel < 3" icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="editOnlineTestMemeberData(tr)"/> -->
                                <feather-icon v-if="activeUserLevel == 2 && (currentOnlineTest.state_val == -5 || currentOnlineTest.state_val >= 0) && activeWorkspace.service == true" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="deleteOnlineTestData(tr.id)"/>
                                <!-- <feather-icon v-if="activeUserLevel == 2 && (currentOnlineTest.state_val == -5 || currentOnlineTest.state_val >= 0) && activeWorkspace.service == true" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="score(tr.id)"/> -->
                              </vs-td>
                            </vs-tr>
                          </tbody>
                        </template>
                      </vs-table>
                    </div>
                  </vx-card>
                </div>
              </div>
            </div>
          </component>
        </div>
      </vs-sidebar>
      <vs-prompt
      class="email-compose"
      title="시험 일정 수정"
      @cancel="clearFields"
      @accept="updateOnlineTest"
      @close="clearFields"
      accept-text="제출"
      cancel-text="취소"
      :active.sync="activePrompt2">
        <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
          <form @submit.prevent>
            <!-- <div class="mt-4" v-if="shareClass.length > 0">
              <v-select placeholder="동기화 수업 없음" v-model="languages_known" multiple :closeOnSelect="false" :options="shareClass" v-validate="'required'" name="lang_known" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div> -->
              <vs-input name="title" label-placeholder="제목" v-model="title" class="w-full mb-6" />
              <div class="mb-2">
                <label style="margin-right:10px;">기간설정</label>
                <!-- <flat-pickr :config="configFromdateTimePicker" v-model="fromDate" placeholder="시작일" @on-change="onFromChange" style="margin-right:10px; margin-bottom:5px;"/>
                <flat-pickr :config="configTodateTimePicker" v-model="toDate" placeholder="종료일" @on-change="onToChange"/> -->
                <flat-pickr :config="configdateTimePicker" v-model="datetime" placeholder="일정 설정" />
              </div>
              <div class="mb-2">
                <label style="margin-right:10px;">제한시간</label>
               <flat-pickr :config="configdateonlyTimePicker" v-model="time" placeholder="제한시간" label-placeholder="제한시간" />
              </div>
              <quill-editor v-model="message" :options="editorOption" />
              <div class="vx-row lg:w-full" style="margin-top:30px; margin-left:2px; margin-right:2px; margin-bottom:-12px; padding:3px;">
                <div class="w-full" v-for="(item, index) in newFileList" v-bind:key="index" style="margin-top:35px; margin-bottom:-3px;">
                  <div class="vx-card text-center" style="margin-top:-20px; margin-bottom:-3px; margin-right:8px; padding:5px;">
                    <div class="vx-card__collapsible-content" style="text-align:center;">
                      <div class="vx-row" style="margin:5px; ">
                        <div  style="width: 90%;">
                          <div align="left" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;">
                            {{item.name}}
                          </div>
                        </div>
                        <div class="vx-row justify-end" style="width:10%; margin-top:-2px; margin-left:5px; margin-bottom:-3px;">
                          <vs-button radius color="danger" type="flat" size="small" icon-pack="feather" icon="icon-x" @click="deletefiles(index)"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row lg:w-full" style="margin-top:30px; margin-left:2px; margin-right:2px; margin-bottom:-12px; padding:3px;">
                <div class="w-full" v-for="(item, index) in onlineTestFileList" v-bind:key="index" style="margin-top:35px; margin-bottom:-3px;">
                  <div class="vx-card text-center" style="margin-top:-20px; margin-bottom:-3px; margin-right:8px; padding:5px;">
                    <div class="vx-card__collapsible-content" style="text-align:center;">
                      <div class="vx-row" style="margin:5px; ">
                        <div  style="width: 90%;">
                          <div align="left" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;">{{item}}</div>
                        </div>
                        <div class="vx-row justify-end" style="width:10%; margin-top:-2px; margin-left:5px; margin-bottom:-3px;">
                          <vs-button radius color="danger" type="flat" size="small" icon-pack="feather" icon="icon-x" @click="deleteFileSubimt(item)"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="filebox" style="margin-top:30px;">
                <label for="inputFile">첨부 파일</label>
                <input type="file" @change="updateFile2" id="inputFile"  name="inputFile" multiple>
              </div>
            </form>
          </form>
        </component>
      </vs-prompt>
      <vs-prompt
      class="email-compose"
      title="제출하기"
      @cancel="clearFields"
      @accept="acceptFileUpload"
      @close="clearFields"
      accept-text="제출"
      cancel-text="취소"
      :active.sync="activePrompt">
        <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
         <form @submit.prevent>
          <label for="inputFile" style="margin-left:10px; margin-top:20px; padding-top:5px; margin-bottom:3px;">결과물을 첨부하세요:)</label>
          <div class="vx-row lg:w-full" style="margin-top:3px; margin-left:2px; margin-right:2px; margin-bottom:-12px; padding:3px;">
            <div class="w-full" v-for="(item, index) in fileList" v-bind:key="index" style="margin-top:35px; margin-bottom:-3px;">
              <div class="vx-card text-center" style="margin-top:-20px; margin-bottom:-3px; margin-right:8px; padding:5px;">
                <div class="vx-card__collapsible-content" style="text-align:center;">
                  <div class="vx-row" style="margin:5px; ">
                    <div  style="width: 90%;">
                      <div align="left" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;">
                        {{item.name}}
                      </div>
                    </div>
                    <div class="vx-row justify-end" style="width:10%; margin-top:-2px; margin-left:5px; margin-bottom:-3px;">
                      <vs-button radius color="danger" type="flat" size="small" icon-pack="feather" icon="icon-x" @click="deletefiles()"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="filebox" style="margin-top:30px;">
            <label for="inputFile">첨부 파일</label>
            <input type="file" @change="updateFile" id="inputFile"  name="inputFile" multiple>
          </div>
        </form>
        </component>
      </vs-prompt>
      <vs-prompt
      class="email-compose"
      title="다시 제출하기"
      accept-text= "업로드"
      cancel-text= "취소"
      @cancel="clearFields"
      @close="clearFields"
      @accept="acceptEditFile"
      :active.sync="activeEditPrompt">
        <component :is="scrollbarTag" class="scoll_area p-2" :settings="settings" :key="$vs.rtl">
         <form @submit.prevent>
          <label for="inputFile" style="margin-left:10px; margin-top:20px; padding-top:5px; margin-bottom:3px;">기존에 있던 파일을 덮어쓰면 복구가 불가능합니다.</label>
          <div class="vx-row lg:w-full" style="margin-top:3px; margin-left:2px; margin-right:2px; padding:3px;">
            <div class="w-full" v-for="(item, index) in fileList" v-bind:key="index" style="margin-top:35px; margin-bottom:-3px;">
              <div class="vx-card text-center" style="margin-top:-20px; margin-bottom:-3px; margin-right:8px; padding:5px;">
                <div class="vx-card__collapsible-content" style="text-align:center;">
                  <div class="vx-row" style="margin:5px; ">
                    <div  style="width: 90%;">
                      <div align="left" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;">
                        {{item.name}}
                      </div>
                    </div>
                    <div class="vx-row justify-end" style="width:10%; margin-top:-2px; margin-left:5px; margin-bottom:-3px;">
                      <vs-button radius color="danger" type="flat" size="small" icon-pack="feather" icon="icon-x" @click="deletefiles()"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="filebox" style="margin-top:30px;">
            <label for="inputFile">첨부 파일</label>
            <input type="file" @change="updateFile" id="inputFile"  name="inputFile" multiple>
          </div>
        </form>
        </component>
      </vs-prompt>
      <vs-prompt
      class="email-compose"
      title="파일 업로드 진행중"
      :buttons-hidden="true"
      :active.sync="activeUploadPrompt">
      <component :is="scrollbarTag" class="scroll-area p-2" :settings="settings" :key="$vs.rtl">
        <div class="vx-row lg:w-full" style="margin-top:3px; margin-left:2px; margin-bottom:15px; margin-right:2px; padding:3px;">
          <div class="w-full" v-for="(item, index) in fileList" v-bind:key="index" style="margin-top:35px; margin-bottom:-3px;">
            <div class="vx-card text-center" style="margin-top:-20px; margin-bottom:-3px; margin-right:8px; padding:5px;">
              <div class="vx-card__collapsible-content" style="text-align:center;">
                <div class="vx-row" style="margin:5px; ">
                  <div  style="width: 90%;">
                    <div align="left" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;">
                      {{item.name}}
                    </div>
                  </div>
                  <vs-progress indeterminate color="primary"></vs-progress>
                </div>
              </div>
            </div>
          </div>
        </div>
      </component>
    </vs-prompt>
    <vs-prompt
    title="파일 다운로드"
    :buttons-hidden="true"
    :active.sync="downloadPrompt">
      <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
        <label for="inputFile" style="margin-left:10px; margin-top:20px; padding-top:5px; margin-bottom:3px;">파일 압축중 - 조금만 기다려주세요 :)</label>
        <div class="vx-row lg:w-full" style="margin-top:3px; margin-left:2px; margin-bottom:15px; margin-right:2px; padding:3px;">
          <vs-progress indeterminate color="primary"></vs-progress>
        </div>
      </component>
    </vs-prompt>

    <vs-popup
    title="성적"
    accept-text="확인"
    @cancel="scoreVal=''"
    @close="scoreVal=''"
    :active.sync="scoreUp">
      <div class="con-exemple-prompt">
        <!-- <vs-input :value="scoreVal" class="mt-3 w-full" /></br> -->
        <span>성적</span>
        <vs-input :value="scoreInfo.score" class="mt-3 w-full" disabled/></br>
        <span>comment</span>
        <vs-textarea :value="scoreInfo.comment" vs-placeholder="코멘트" class="mt-3 w-full" disabled/>
      </div>
    </vs-popup>

    <vs-prompt
    title="성적 입력"
    accept-text="업로드"
    cancel-text="취소"
    @cancel="scoreVal=''; comment=''"
    @accept="updateScore"
    @close="scoreVal=''; comment=''"
    :active.sync="scorePrompt">
      <div class="con-exemple-prompt">
        <p class="text"><strong> {{scoreInfo.name}}</strong> 성적을 입력해주세요.</p>
        <!-- <vs-input placeholder="예: A" vs-placeholder="성적 입력" v-model="scoreVal" class="mt-3 w-full" /></br> -->
        <vs-input  v-model="scoreVal" placeholder="예: A" vs-placeholder="성적 입력" class="mt-3 w-full" /></br>
        <span>comment</span>
        <vs-textarea  v-model="comment" class="mt-3 w-full" />
      </div>
    </vs-prompt>

    <vs-prompt
    title="파일 업로드중"
    :buttons-hidden="true"
    :active.sync="uploadPrompt">
      <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
        <label style="margin-left:10px; margin-top:20px; padding-top:5px; margin-bottom:3px;">파일 업로드중 - 조금만 기다려주세요 :)</label>
        <div class="vx-row lg:w-full" style="margin-top:3px; margin-left:2px; margin-bottom:15px; margin-right:2px; padding:3px;">
          <vs-progress indeterminate color="primary"></vs-progress>
        </div>
      </component>
    </vs-prompt>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import OnlineTestCard from "@/views/apps/space/dashboard/onlineTest/OnlineTestCard.vue"
import { quillEditor } from 'vue-quill-editor'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import VueCountdown from '@chenfengyuan/vue-countdown'
import vSelect from 'vue-select'

export default {
  props: {
    openOnlineTestId: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      languages_known         :'',
      comment                 : '',
      scorescore              : '',
      startTime               : null,
      endTime                 : null,
      sidebarData             : {},
      activePrompt2           : false,
      showThread              : false,
      activePrompt            : false,
      activeEditPrompt        : false,
      message                 : '',
      title                   : '',
      fileList                : [],
      newFile                 : '',
      onlineTestInfo              : '',
      progress                : false,
      fileName                : '',
      value1                  : '',
      selelctOnlineTestMemeberInfo: '',
      scorePrompt             : false,
      scoreUp                 : false,
      scoreVal                : '',
      fromDate                : null,
      toDate                  : null,
      activeUploadPrompt      : false,
      scoreInfo               : '',
      downloadPrompt          : false,
      vxCardObject            : 'bg-success px-4',
      deleteFileName          : '',
      newFileList             : [],
      onlineTestFileList          : [],
      uploadPrompt            : false,
      // configFromdateTimePicker: {
      //   minDate: null,
      //   maxDate: null
      // },
      // configTodateTimePicker: {
      //   minDate: null
      // },
      time: null,
      configdateonlyTimePicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true
      },
      datetime: null,
      configdateTimePicker: {
         enableTime: true,
         maxDate: null,
         dateFormat: 'Y-m-d H:i'
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.50,
      },
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'link', 'blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'font': [] }],
          ],
        },
        placeholder: '공지사항 내용을 입력해 주세요 :)'
      },
    }
  },
  watch: {
    isSidebarActive(value) {
      if (!value) {
        this.$emit('closeSidebar')
        setTimeout(() => {
          this.showThread = false
        }, 500)
      }
    },
    openOnlineTestId() {
      this.$vs.loading()
        if(this.currentOnlineTest && this.currentOnlineTest.file_names){
          this.onlineTestFileList = this.currentOnlineTest.file_names
        } else {
          this.onlineTestFileList = []
        }
        this.startTime = this.currentOnlineTest.start_time
        this.endTime = this.currentOnlineTest.end_time
        if(this.currentOnlineTest.state_val == -99){
          this.vxCardObject = 'bg-dark px-4'
        }
        else if (this.currentOnlineTest.state_val == 0){
         this.vxCardObject = 'bg-danger px-4'
        }
        else if (this.currentOnlineTest.state_val != -99 && this.currentOnlineTest.state_val < 0){
         this.vxCardObject = 'bg-warning px-4'
        }
        else {
         this.vxCardObject = 'bg-success px-4'
        }
        this.$store.dispatch("onlineTest/getOnlineTestMember",this.openOnlineTestId).then(()=>{
          this.$vs.loading.close()
        }).catch(() => {
         this.$vs.loading.close()
           this.$vs.notify({
             color: 'danger',
             title: '에러',
             text: '서버 에러 관리자에게 문의해주세요'
           })
        })
      }
    },
    computed: {
      shareClass() {
        return this.$store.state.space.shareClass
      },
      currentOnlineTest() {
        return this.$store.getters['onlineTest/getOnlineTest'](this.openOnlineTestId)
      },
      activeUserLevel() {
        return this.$store.state.space.ActiveDashBoardLevel
      },
      scrollbarTag() { return this.$store.getters.scrollbarTag },
      products() {
        return this.$store.state.dataList.products
      },
      onlineTestMember() {
        return this.$store.state.onlineTest.onlineTestMembers
      },
      currentPage() {
        if(this.isMounted) {
          return this.$refs.table.currentx
        }
        return 0
      },
      activeWorkspace() {
        return this.$store.state.space.ActiveSpaceInfo
      },
      queriedItems() {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
      },
    },
    created() {
      // console.log(new Date(currentOnlineTest.end_time).getTime() - new Date().getTime())
    },
    methods: {
      handleCountdownEnd(){
        // console.log('handleCountdownEnd')
      },
      getCountdonwTime(){
        // console.log(this.currentOnlineTest.end_time)
        var t1 = this.$moment(new Date(), 'YYYY-MM-DD HH:mm')
        var t2 = this.$moment(this.currentOnlineTest.end_time, 'YYYY-MM-DD HH:mm')
        var milliseconds = Math.floor(this.$moment.duration(t2.diff(t1)).asMilliseconds())
        return milliseconds
      },
      deletefiles2(index){
        this.newFileList.splice(index,1)
      },
      fileDonwload(item){
        this.$store.dispatch('onlineTest/onlineTestFileDonwload', {'param':'id='+this.openOnlineTestId+'&'+'name='+item, 'name': item}).then(() => {
        })
      },
      downloadAllFile(){
        if(this.onlineTestMember.length == 0){
          this.$vs.notify({
            color: 'danger',
            title: '파일 없음.',
            text: '제출된 파일이 없습니다'
          })
          return
        }
        this.downloadPrompt= true
        this.$store.dispatch("onlineTest/fileCompressOnlineTestMembe", {id:this.openOnlineTestId, file_name: this.currentOnlineTest.title+'.zip'})
        .then(()=>{
          this.$store.dispatch("onlineTest/fileDonwloadOnlineTestMembe", {'param':'onlineTest_id='+this.openOnlineTestId+'&'+'id=all', 'name': this.currentOnlineTest.title+'.zip'})
          this.downloadPrompt= false
          this.$vs.notify({
          color:'success',
          title:'압축 완료'
          })
        }).catch(() => {
          this.downloadPrompt= false
          this.$vs.notify({
          color: 'danger',
          title:'실패',
          text:'관리자에게 문의 하세요'
          })
        })
      },
      score(info){
        this.scoreInfo = info
        this.scoreUp = true
      },
      editScore(info){
        this.scoreInfo = info
        this.scorePrompt = true
      },
      updateScore(){
        this.$store.dispatch("onlineTest/updateOnlineTestMemberScore", {workspace_id:this.activeWorkspace.id, id:this.scoreInfo.id, score:this.scoreVal, comment:this.comment}).then(()=>{
          this.$vs.notify({
          color:'success',
          title:'성적 업로드 완료',
          text:'성적을 업로드 하였습니다'
          })
        }).catch(() => {
          this.$vs.notify({
          color: 'danger',
          title:'실패',
          text:'관리자에게 문의 하세요'
          })
        })
      },
      // onFromChange(selectedDates, dateStr) {
      //   this.$set(this.configTodateTimePicker, 'minDate', dateStr)
      // },
      // onToChange(selectedDates, dateStr) {
      //   this.$set(this.configFromdateTimePicker, 'maxDate', dateStr)
      // },
      downloadFile(val){
        this.onlineTestInfo = val
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `파일 저장`,
          text: '해당 파일을 저장하시겠습니까?',
          accept: this.acceptDownload
        })
      },
      acceptDownload(){
        this.$store.dispatch("onlineTest/fileDonwloadOnlineTestMembe", {'param':'onlineTest_id='+this.onlineTestInfo.onlineTest_id+'&'+'id='+this.onlineTestInfo.id, 'name': this.onlineTestInfo.file_name})
      },
      deletefiles(){
        this.fileList = []
      },
      onlineTestMemberItem(){
        this.fileList = []
        this.activePrompt = true
      },
      updateFile(){
        var file = document.getElementById("inputFile").files[0]
        if (file.size > this.$store.state.uploadFileMaxSize) {
          this.$vs.notify({
            color: 'danger',
            title: '에러',
            text: '첨부파일 용량은 15M까지 사용가능합니다'
          })
          return
        }
        this.newFile = ''
        this.fileList = []
        this.fileList.push(file)
        this.newFile = file
      },
      updateFile2(){
        var size = 0
        if(this.currentOnlineTest.file_size){
          size = this.currentOnlineTest.file_size
        }
        var samefile = false
        for(var index = 0; index < document.getElementById("inputFile").files.length; index++) {
          var file = document.getElementById("inputFile").files[index]
          size = size + file.size
          if (size > this.$store.state.uploadFileMaxSize) {
            this.$vs.notify({
              color: 'danger',
              title: '에러',
              text: '첨부파일 용량은 15M까지 사용가능합니다'
            })
            break
          }
          if (this.onlineTestFileList.findIndex(function(item){return item == file.name}) == -1 &&
          this.newFileList.findIndex(function(item){return item.name == file.name}) == -1) {
            this.newFileList.push(file)
          }else {
            samefile = true
          }
        }
        if (samefile){
          this.$vs.notify({
            color:'danger',
            title:'중복파일',
            text:'같은 이름이 있습니다 확인해주세요'
          })
        }
      },
      close(){
        this.$vs.notify({
          color:'danger',
          title:'닫기',
          text:'저장하지 않고 닫았습니다'
        })
      },
      acceptFileUpload(){
        if(this.fileList.length != 1){
          this.$vs.notify({color:'danger',title:'첨부파일 에러',text:'첨부파일을 다시 확인해주세요'})
          return
        }
        this.uploadPrompt = true
        this.$store.dispatch("onlineTest/createOnlineTestMember", {id:this.openOnlineTestId, title:'', detail:'', file:this.fileList[0], workspace_id:this.activeWorkspace.id}).then(()=>{
          this.uploadPrompt = false
          this.$vs.notify({color:'success',title:'제출 완료',text:'결과물 제출을 완료하였습니다'})
        }).catch(() => {
          this.uploadPrompt = false
          this.$vs.notify({
            color: 'danger',
            title: '에러',
            text: '제출 날짜를 확인해 주세요'
          })
        })
      },
      editOnlineTest() {
        this.title = this.currentOnlineTest.title
        this.message = this.currentOnlineTest.detail
        this.datetime = this.currentOnlineTest.start_time
        this.time = this.currentOnlineTest.timeout
        this.fileList = []
        this.newFileList = []
        if(this.currentOnlineTest.file_name){
          this.fileList.push({name:this.currentOnlineTest.file_name})
        }
        this.activePrompt2 = true
      },
      clearFields() {
        this.$nextTick(() => {
          this.title = ''
          this.message = ''
          this.fileList = []
          this.newFileList = []
        })
      },
      moveTo(to) {
        this.$emit('closeSidebar')
        this.$emit('moveTo', to)
      },
      deleteOnlineTest() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `공지사항 삭제`,
          text: '모든 첨부/제출 파일 및 공지사항을 삭제하시겠습니까?',
          accept: this.acceptDelete
        })
      },
      acceptDelete() {
        this.$store.dispatch('onlineTest/deleteOnlineTest', this.openOnlineTestId)
        .then(()=>{
          this.$emit('closeSidebar')
          this.$vs.notify({
            color: 'success',
            title: '삭제 완료',
            text: '선택된 글이 삭제되었습니다.'
          })
        })
      },
      updateOnlineTest() {
        this.uploadPrompt = true
        var shareClass = []
        for (var i in this.languages_known){
          shareClass.push(this.languages_known[i].value)
        }
        var endTime = this.$moment(this.datetime, 'YYYY-MM-DD HH:mm')
        var limit = this.$moment(this.time, 'HH:mm')
        endTime.add(limit.hours(), 'hours')
        endTime.add(limit.minutes(),'minutes')
        this.$store.dispatch('onlineTest/updateOnlineTest', {param:{id:this.openOnlineTestId, title:this.title, detail:this.message, workspace_id:this.activeWorkspace.id,
          start:this.datetime, timeout:this.time, end:endTime, size:this.newFileList.length, "share_class":shareClass}, files:this.newFileList})
        .then((resolve)=>{
          //TODO 코드 로직 수정 필요.
          var t1 = this.$moment(new Date, 'YYYY-MM-DD HH:mm')
          var index = this.$store.state.onlineTest.onlineTests.findIndex(function(item){return item.id == resolve.data.data.id})
          this.setDateState(index, this.currentOnlineTest, t1)
          if(this.currentOnlineTest && this.currentOnlineTest.file_names){
            this.fileList = this.currentOnlineTest.file_names
          }
          this.uploadPrompt = false
          this.$vs.notify({
            color: 'success',
            title: '수정 완료'
          })
        }).catch(() => {
          this.uploadPrompt = false
          this.$vs.notify({
            color: 'danger',
            title: '에러',
            text: '관리자에게 문의해 주세요.'
          })
        })
      },
      editOnlineTestMemeberData(data) {
        this.newFile = ''
        this.fileList = []
        this.selelctOnlineTestMemeberInfo = data
        this.fileList.push({name:data.file_name})
        this.activeEditPrompt = true
      },
      deleteFileOnlineTest(name){
        this.deleteFileName = name
        this.acceptFileDelete()
      },
      acceptFileDelete(){
        this.$store.dispatch('onlineTest/deleteOnlineTestFile','id='+this.openNoticeId+'&'+'name='+this.deleteFileName).then(()=>{
          if(this.currentOnlineTest && this.currentOnlineTest.file_names){
            this.onlineTestFileList = this.currentOnlineTest.file_names
          } else {
            this.onlineTestFileList = []
          }
          this.$vs.notify({
            color: 'danger',
            title: '삭제 완료',
            text: '선택된 파일이 삭제되었습니다.'
          })
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '삭제 실패',
            text: '선택된 파일이 없습니다.'
          })
        })
      },
      acceptEditFile() {
        if(this.newFile){
          this.uploadPrompt = true
          this.$store.dispatch('onlineTest/updateOnlineTestMember', {id:this.selelctOnlineTestMemeberInfo.id, title:'', detail:'', file:this.newFile}).then(()=>{
            this.uploadPrompt = false
            this.$vs.notify({color:'success',title:'수정 완료',text:'결과물 수정을 완료하였습니다.'})
          }).catch(() => {
            this.uploadPrompt = false
            this.$vs.notify({
              color: 'danger',
              title: '에러',
              text: '제출 날짜를 확인해 주세요.'
            })
          })
        }
      },
      deleteOnlineTestData(id) {
        this.$store.dispatch('onlineTest/deleteOnlineTestMember', id).then(()=> {
          this.$vs.notify({
            color:'danger',
            title:'결과물 삭제 완료',
            text:'제출했던 결과물을 삭제하였습니다.'
          })
        })
      },
      setDateState(itemIndex, onlineTestInfo, t1){
        var start_time = this.$moment(onlineTestInfo.start_time, 'YYYY-MM-DD HH:mm')
        var end_time = this.$moment(onlineTestInfo.end_time, 'YYYY-MM-DD HH:mm')
        var day = Math.floor(this.$moment.duration(start_time.diff(t1)).asDays())
        var minute = Math.floor(this.$moment.duration(start_time.diff(t1)).asMinutes())
        var end_minute = Math.floor(this.$moment.duration(end_time.diff(t1)).asMinutes())
        // var limit = Math.floor(this.$moment.duration(end_time.diff(start_time)).asMinutes())
        if (day > 0){
          this.$store.commit('onlineTest/SET_ONLINETEST_DATE_UPDATE', {index:itemIndex, val:day})
          this.vxCardObject = 'bg-success px-4'
        }
        else if(day == 0 && minute > 0){
          var val = Math.floor(minute/60)*-1
          this.$store.commit('onlineTest/SET_ONLINETEST_DATE_UPDATE', {index:itemIndex, val:val})
          this.vxCardObject = 'bg-warning px-4'
        }
        else if(minute <= 0 && end_minute >= 0){
          this.$store.commit('onlineTest/SET_ONLINETEST_DATE_UPDATE', {index:itemIndex, val:0})
          this.vxCardObject = 'bg-danger px-4'
        }
        else {
          this.$store.commit('onlineTest/SET_ONLINETEST_DATE_UPDATE', {index:itemIndex, val:-99})
          this.vxCardObject = 'bg-dark px-4'
        }
      },
    },
    components: {
      quillEditor,
      VuePerfectScrollbar,
      'onlineTestCard': OnlineTestCard,
      flatPickr,
      'countdown': VueCountdown,
      vSelect
    }
}

</script>

<style lang="scss">
.text {
    font-size: 16px;
    max-width: 400px;
    line-height: 1.5;
}
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
